<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item
          label="名称"
          prop="userName"
        >
          <el-input
            v-model="searchForm.userName"
            placeholder="名称"
            style="width: 100px;"
          />
        </el-form-item>

        <el-form-item
                label="用户名"
                prop="userCode"
        >
          <el-input
                  v-model="searchForm.userCode"
                  placeholder="用户名"
                  style="width: 100px;"
          />
        </el-form-item>
        <el-form-item
                label="手机号码"
                prop="mobileno"
        >
          <el-input
                  v-model="searchForm.mobileno"
                  placeholder="手机号码"
                  style="width: 100px;"
          />
        </el-form-item>
        <el-form-item
                label="openid"
                prop="gzh_openid"
        >
          <el-input
                  v-model="searchForm.gzh_openid"
                  placeholder="openid"
                  style="width: 100px;"
          />
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </template>
    <el-button
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      @click="add"
    >
      新增
    </el-button>
    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        label="公司"
      >
        <template slot-scope="scope">
          {{scope.row.agentname}}
        </template>
      </el-table-column>

      <el-table-column
        label="法人姓名"
        prop="legal"
        sortable="custom"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.legal}}
        </template>
      </el-table-column>
      <el-table-column
        label="手机号"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.mobileNo}}
        </template>
      </el-table-column>
      <el-table-column
        label="用户名"
        prop="userCode"
        sortable="custom"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.userCode}}
        </template>
      </el-table-column>
      <el-table-column
              label="合作期限"
              prop="userCode"
              sortable="custom"
              :show-overflow-tooltip="true"
              width="150"
      >
        <template slot-scope="scope">
          {{scope.row.contractstdate}}/{{scope.row.contractendate}}
        </template>
      </el-table-column>
      <!-- <el-table-column
               label="档案编号"
               prop="businessid_two"
               sortable="custom"
               :show-overflow-tooltip="true"
               width="150"
       >
         <template slot-scope="scope">
           {{scope.row.businessid_two}}

         </template>
       </el-table-column>


       <el-table-column
               label="签名图片"
       >
         <template slot-scope="scope">
           <div v-if="scope.row.businessid!=null && scope.row.businessid!=''">
             <img :src= "getImgUrl(scope.row)" style="width: 100px;height: 100px; "/>
           </div>

         </template>
       </el-table-column>-->


       <el-table-column
               label="上级代理"
               prop="qrcodeid"
               sortable="custom"
               :show-overflow-tooltip="true"
               width="70"
       >
         <template slot-scope="scope">
           <div v-if="scope.row.qrcodeid=='-1'">
             公司
           </div>
           <div v-else-if="scope.row.qrcodeid=='5'">
             地市合伙人
           </div>


         </template>
       </el-table-column>
       <el-table-column
               label="状态"
               prop="pass"
               sortable="custom"
               :show-overflow-tooltip="true"
       >
         <template slot-scope="scope">
           <div v-if="scope.row.pass=='0'">
             已签约
           </div>
           <div v-else-if="scope.row.pass=='1'  || scope.row.pass=='3'">
             未签约
           </div>
           <div v-else-if="scope.row.pass=='2'">
             待审核
           </div>
         </template>
       </el-table-column>
       <el-table-column
         fixed="right"
         label="操作"
         align="center"
         width="400"
       >
         <template slot-scope="scope">
           <el-button type="primary" plain  size="mini"    @click="openEditForm(scope.row)">编辑</el-button>
           <el-button type="primary" plain  size="mini"    @click="openViewForm(scope.row)">详情</el-button>
           <el-button type="primary" plain size="mini"      v-if="scope.row.pass=='1'  && (is_dl_type=='-1' || is_agentid=='7080007') "  @click="del(scope.row.agentid,0)">启用</el-button>

           <el-button type="primary" plain size="mini"     v-if="scope.row.pass=='0'  && (is_dl_type=='-1' || is_agentid=='7080007') " @click="del(scope.row.agentid,1)">禁用</el-button>
           <el-button type="primary" plain size="mini"     v-if="scope.row.pass=='3'" @click="del(scope.row.agentid,2)">提交审核</el-button>
           <el-button type="primary" plain size="mini"    @click="reset(scope.row.userId)">重置密码</el-button>
           <!--<el-button type="primary" plain size="mini"   v-if="scope.row.tjagentid==is_agentid"  @click="openShareForm(scope.row)">分润设置</el-button>-->
        </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
    <edit-form
      :oneagent="oneagent"
      v-model="editFormVisible"
      @submit="getTableData"
    />
    <view-form
            :oneagent="oneagent"
            v-model="viewFormVisible"
            @submit="getTableData"
    />

    <share-form
            :oneagent="oneagent"
            v-model="shareFormVisible"
            @submit="getTableData"
    />

  </d2-container>
</template>
<script>
import * as agentService from "@/api/sys/agent";
import editForm from "./editForm";
import viewForm from "./viewForm";
import shareForm from '@/pages/sys/oneagent/shareForm';
import util from '@/libs/util.js'
export default {
  name: "TwoagentPage",
  components: { editForm  ,viewForm,shareForm },
  data() {
    return {
      searchForm: {
          userName: "",
          userCode: ""
      },
        is_agentid:"",
        is_dl_type:util.cookies.get('dl_type'),
      loading: false,
      tableData: [],
      multipleSelection: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: "",
        order: ""
      },
        oneagent: {},
      editFormVisible: false,
        viewFormVisible: false,
        shareFormVisible: false
    };
  },
  mounted() {
      if(util.cookies.get('agentid')==null || util.cookies.get('agentid')==""){
          this.is_agentid="7080007";
      }else{
          this.is_agentid=util.cookies.get('agentid');
      }
    this.getTableData();
  },
  methods: {
    getTableData() {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
          agentid: util.cookies.get('agentid'),
          dl_type: util.cookies.get('dl_type'),
          dl_type2:'6',
          xt_id:util.cookies.get('xt_id'),
        descending: this.sort.order === "descending",
        filter: this.searchForm
      };
        agentService.getAgentPagedListYys(query).then(data => {
        this.tableData = data.rows;
        this.page.total = data.totalCount;
      });
    },
      getImgUrl(row){
          return "https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/"+row.businessid;
      },
    handleSearchFormSubmit() {
      this.getTableData();
    },
    handleSearchFormReset() {
      this.$refs.searchForm.resetFields();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSortChange(val) {
      this.sort.prop = val.prop;
      this.sort.order = val.order;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getTableData();
    },
    openEditForm(oneagent) {
      this.oneagent = oneagent;
      this.editFormVisible = true;
        this.viewFormVisible = false;
        this.shareFormVisible= false;
    },
      openViewForm(agent) {
          this.oneagent = agent;
          this.viewFormVisible = true;
          this.editFormVisible = false;
          this.shareFormVisible= false;
      },
      openShareForm(agent) {
          this.oneagent = agent;
          this.shareFormVisible= true;
          this.viewFormVisible = false;
          this.editFormVisible = false;
      },
    add() {
      this.oneagent = {};
      this.editFormVisible = true;
    },
      del(agentid,type) {
          let msg = type == 1 ? "禁用" : "启用";
          this.$confirm("确认"+msg+"操作？", "确认信息", {
              distinguishCancelAndClose: true,
              confirmButtonText: msg,
              cancelButtonText: "取消"
          }).then(() => {
              agentService.delAgent({agentid:agentid,type:type}).then(() => {
                  this.getTableData();
              });
          });
      },
      reset(userId) {
        let msg = "重置密码";
      this.$confirm("确定要重置该帐号的密码吗？！重置后的密码为123456", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: msg,
        cancelButtonText: "取消"
      }).then(() => {
          agentService.resetAgent({userId:userId}).then(() => {
          this.getTableData();
        });
      });
    }
  }
};
</script>
